export { default } from './image-carousel';



// WEBPACK FOOTER //
// ./app/common/components/image-carousel/index.js